const jaMessages = {
  ja: {
    mediaPage: {
      varieties: {
        policies: '利用規約',
        corporate_info: '会社情報',
        info: 'サイト情報'
      }
    },
    post: {
      status: {
        published: '公開',
        closed: '非公開',
        draft: '下書き'
      }
    },
    order: {
      status: {
        writing: '執筆中',
        under_inspection: '検収中',
        completed: '執筆完了'
      }
    }
  }
}

export default jaMessages
